import React, { Component } from 'react';
import NoSSR from 'react-no-ssr';
import MediaQuery from 'react-responsive';
import PropTypes from 'prop-types';
import { Button } from '@spotahome/ui-library';
import '@spotahome/ui-library/lib/components/Button.css';

import { MQ_DESKTOP_MIN_WIDTH } from '../constants';

import './ButtonWithIcon.scss';

class ButtonWithIcon extends Component {
  state = {
    hover: false
  };

  handleOnMouseEnter = () => {
    this.setState({ hover: true });
  };

  handleOnMouseLeave = () => {
    this.setState({ hover: false });
  };

  render() {
    const { className, href, title, handleOnClick, ...rest } = this.props;
    return (
      <Button
        alt
        className={`${className} button-with-icon`}
        href={href}
        title={title}
        onMouseEnter={this.handleOnMouseEnter}
        onMouseLeave={this.handleOnMouseLeave}
        onClick={handleOnClick}
        {...rest}
      >
        {this.props.children(this.state.hover)}
        <NoSSR>
          <MediaQuery minWidth={MQ_DESKTOP_MIN_WIDTH}>
            <span>{title}</span>
          </MediaQuery>
        </NoSSR>
      </Button>
    );
  }
}

ButtonWithIcon.propTypes = {
  className: PropTypes.string.isRequired,
  href: PropTypes.string,
  title: PropTypes.string.isRequired,
  children: PropTypes.func.isRequired,
  handleOnClick: PropTypes.func
};

ButtonWithIcon.defaultProps = {
  href: null,
  handleOnClick: () => {}
};

export default ButtonWithIcon;
